import { PlaylistEnum } from "../enum/PlaylistEnum";
import { IReguaLogo } from "../interfaces/IReguaLogo";
import ReguaLogo from "../assets/Regua.svg";
import ReguaLogoPromoverAlfabetizacao from "../assets/img_regua_vertical.png";



export const ListReguaLogo: IReguaLogo[] = [
    {
        type: PlaylistEnum.SEMINARIO,
        regua: ReguaLogo
    },
    {
        type: PlaylistEnum.PROMOVER_ALFABETIZACAO,
        regua: ReguaLogoPromoverAlfabetizacao
    }
]